import React from 'react';

const RadioS1 = ({options, checked, onChange, radioItemClass=''}) => {
	return (
		<div className='flex flex-wrap -mx-2.5'>

			{options.map(option => {
				const isChecked = option.value === checked;
				return(
					<div className='relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-6/12 max-w-[50%]'>
						<div className={`radio-item ${isChecked ? '--checked' : ''} ${radioItemClass}`} onClick={() => onChange(option)}>
							<span className='radio-item-check'></span>
							<span>{option.label}</span>
						</div>
					</div>
				)
			})}

		</div>
	);
};

export default RadioS1;
